import React from "react";
import "./ScenarioInformation.css";

export default function ScenarioInformation({ scenarioId }) {
  const closingBrace = scenarioId.indexOf("}");
  const workshopId = scenarioId.startsWith("{") && closingBrace > 0
    ? scenarioId.slice(1, closingBrace) : "";
  const missionsIndex = scenarioId.indexOf("Missions/");
  const missionFile = missionsIndex >= 0
    ? scenarioId.slice(missionsIndex + "Missions/".length).split("/").pop() : "";
  const missionName = missionFile.replace(/\.conf$/, "").replace(/_/g, " ").trim();
  const valid = scenarioId.startsWith("{") && closingBrace >= 1
    && missionsIndex >= 0 && scenarioId.endsWith(".conf");

  return (
    <section className="scenario-information" aria-labelledby="scenario-information-heading">
      <h4 id="scenario-information-heading">Scenario Information</h4>
      <dl>
        <div><dt>Workshop ID:</dt><dd>{workshopId || "Not available"}</dd></div>
        <div><dt>Mission File:</dt><dd>{missionFile || "Not available"}</dd></div>
        <div><dt>Mission Name:</dt><dd>{missionName || "Not available"}</dd></div>
      </dl>
      <p role="status" className={valid ? "scenario-valid" : "scenario-invalid"}>
        {valid ? "✓ Valid Scenario ID" : "⚠ Invalid Scenario ID"}
      </p>
    </section>
  );
}
